import LxcError from "~/core/models/LxcError.class";
import type { Pki } from "~/modules/pki/models/Pki.interface";
import pkiService from "~/modules/pki/services/pki.service";

export function useUpdatePki() {
  const service = pkiService.updatePki.bind(pkiService);
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function updatePki(alias: string, pki: Pki): Promise<void> {
    isLoading.value = true;
    error.value = undefined;

    const response = await service(alias, pki);

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    updatePki,
    isLoading,
    error,
  };
}
